import React, { useEffect, createElement } from 'react';
import { Layout } from '../components/Layout';
export function RegistrationIntro() {
  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'luma-checkout';
    script.src = 'https://embed.lu.ma/checkout-button.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      const existingScript = document.getElementById('luma-checkout');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);
  return <Layout data-id="element-443">
      <div className="max-w-6xl mx-auto px-6 py-16" data-id="element-444">
        {/* Hero Section */}
        <div className="text-center mb-16" data-id="element-445">
          <h1 className="text-6xl md:text-7xl font-black text-black mb-6 leading-tight" data-id="element-446">
            This Is Where It <span className="text-voices-red" data-id="element-447">Shifts</span>.
          </h1>
          <p className="text-2xl text-gray-700 max-w-4xl mx-auto leading-relaxed" data-id="element-448">
            Something extraordinary is coming. A moment. A movement. A shift.
          </p>
        </div>
        {/* Main Content */}
        <div className="bg-gradient-to-br from-voices-cream to-white rounded-3xl shadow-2xl p-8 md:p-12 mb-12 border-l-8 border-voices-gold" data-id="element-449">
          <p className="text-xl text-gray-800 mb-8 leading-relaxed" data-id="element-450">
            On <strong data-id="element-451">Saturday, January 10, 2026</strong>, over{' '}
            <strong data-id="element-452">
              300 young professionals, creatives, and entrepreneurs
            </strong>{' '}
            will gather at <strong data-id="element-453">The Somi Place, Lekki</strong>, for a
            one-of-a-kind live experience that blends faith, clarity, and
            community — all in one room.
          </p>
          {/* CTA Button and Flyer */}
          <div className="flex flex-col items-center gap-6 mb-12" data-id="element-454">
            <a href="https://luma.com/event/evt-b1qkPhaGR0lif07" className="luma-checkout--button bg-voices-red text-white px-12 py-4 rounded-lg font-bold text-xl hover:bg-red-700 transition-colors inline-block" data-luma-action="checkout" data-luma-event-id="evt-b1qkPhaGR0lif07" data-id="element-455">
              Register for Event
            </a>
            <a href="https://getdp.co/5Lq" target="_blank" rel="noopener noreferrer" className="text-voices-gold hover:text-orange-600 font-semibold underline" data-id="element-456">
              Get Your Personalized Event DP
            </a>
          </div>
          <p className="text-lg text-gray-700 leading-relaxed mb-8" data-id="element-457">
            This isn't just another event. It's a <strong data-id="element-458">soul check</strong>, a{' '}
            <strong data-id="element-459">sounding board</strong>, and a <strong data-id="element-460">safe space</strong>{' '}
            for those who are searching, starting, scaling, surrendered, or
            stewarding their next season. It's your invitation to pause,
            reflect, and receive the insight, energy, and alignment you need for
            your next big shift.
          </p>
        </div>
        {/* What to Expect */}
        <div className="mb-12" data-id="element-461">
          <h2 className="text-4xl font-bold text-black mb-8 text-center" data-id="element-462">
            What to Expect
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-463">
            {[{
            icon: '🔥',
            text: 'Honest, raw, and relatable conversations'
          }, {
            icon: '🎙️',
            text: 'Live "Voices with Victoria" podcast sessions'
          }, {
            icon: '💫',
            text: 'Elevated networking with purpose-driven peers'
          }, {
            icon: '🎶',
            text: 'Music, spoken word, and moments of worship'
          }, {
            icon: '🧠',
            text: 'Practical wisdom from thought leaders and doers'
          }, {
            icon: '✨',
            text: 'A declaration wall — where you declare your next shift'
          }].map((item, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow border-b-4 border-voices-gold" data-id="element-464">
                <div className="text-4xl mb-3" data-id="element-465">{item.icon}</div>
                <p className="text-gray-800 font-medium" data-id="element-466">{item.text}</p>
              </div>)}
          </div>
        </div>
        {/* CTA Section */}
        <div className="bg-gradient-to-br from-voices-red to-red-700 text-white rounded-3xl p-10 md:p-12 mb-12" data-id="element-467">
          <div className="flex flex-col items-center gap-6 mb-8" data-id="element-468">
            <a href="https://luma.com/event/evt-b1qkPhaGR0lif07" className="luma-checkout--button bg-white text-voices-red px-12 py-4 rounded-lg font-bold text-xl hover:bg-gray-100 transition-colors inline-block" data-luma-action="checkout" data-luma-event-id="evt-b1qkPhaGR0lif07" data-id="element-469">
              Register for Event
            </a>
            <a href="https://getdp.co/5Lq" target="_blank" rel="noopener noreferrer" className="text-white hover:text-voices-cream font-semibold underline" data-id="element-470">
              Get Your Personalized Event DP
            </a>
          </div>
        </div>
        {/* Why You Should Be There */}
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 mb-12 border-l-8 border-voices-red" data-id="element-471">
          <h2 className="text-4xl font-bold text-black mb-6 text-center" data-id="element-472">
            Why You Should Be There
          </h2>
          <p className="text-xl text-gray-800 mb-6 leading-relaxed" data-id="element-473">
            Because life doesn't shift by accident. It shifts when you lean into
            the right spaces — with the right people, guided by the right
            voices.
          </p>
          <p className="text-xl text-gray-800 mb-8 leading-relaxed" data-id="element-474">
            You'll leave{' '}
            <strong data-id="element-475">refreshed, stretched, supported, and equipped</strong> to
            design your best year yet. This is where{' '}
            <strong data-id="element-476">faith meets clarity</strong>. This is where{' '}
            <strong data-id="element-477">your story transforms</strong>. This is where it{' '}
            <strong className="text-voices-red" data-id="element-478">shifts</strong>.
          </p>
          <div className="bg-voices-cream p-6 rounded-xl mb-8" data-id="element-479">
            <h3 className="text-2xl font-bold text-black mb-4" data-id="element-480">
              Join the Movement
            </h3>
            <p className="text-lg text-gray-800 mb-2" data-id="element-481">
              🎟️ <strong data-id="element-482">Physical Access:</strong> Only 300 seats available
              (Free but exclusive — registration required)
            </p>
            <p className="text-lg text-gray-800 font-semibold" data-id="element-483">
              Don't wait for change — step into it.
            </p>
          </div>
          {/* Final CTA */}
          <div className="flex flex-col items-center gap-4" data-id="element-484">
            <a href="https://luma.com/event/evt-b1qkPhaGR0lif07" className="luma-checkout--button bg-voices-red text-white px-12 py-4 rounded-lg font-bold text-xl hover:bg-red-700 transition-colors inline-block" data-luma-action="checkout" data-luma-event-id="evt-b1qkPhaGR0lif07" data-id="element-485">
              Register for Event
            </a>
            <p className="text-gray-600 text-center" data-id="element-486">
              and secure your spot at <strong data-id="element-487">#VoicesLive2026</strong>
            </p>
          </div>
        </div>
        {/* Hashtags */}
        <div className="text-center text-gray-600" data-id="element-488">
          <p className="text-lg font-semibold" data-id="element-489">
            #VoicesWithVictoria | #ThisIsWhereItShifts
          </p>
        </div>
      </div>
    </Layout>;
}